import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoBack } from '@/hooks/useGoBack';
import { useT } from '@/i18n/react';

export interface ScreenHeaderProps {
  title: string;
  /** Ha megadod, ide navigál vissza; egyébként egyet lép vissza, előzmény nélkül a Home-ra (`useGoBack`). */
  backTo?: string;
  /** Jobb oldali akció (pl. Mentés, ⋯ menü). */
  action?: ReactNode;
  className?: string;
}

export function ScreenHeader({ title, backTo, action, className }: ScreenHeaderProps) {
  const navigate = useNavigate();
  const goBack = useGoBack();
  const t = useT();

  return (
    <header className={`screen-header${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className="screen-header__back"
        aria-label={t.common.back}
        onClick={() => (backTo ? navigate(backTo) : goBack())}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="m15 6-6 6 6 6" />
        </svg>
      </button>
      <h1 className="screen-header__title">{title}</h1>
      {action}
    </header>
  );
}
